<template>
    <button type="submit" @click="handleAddToCart" name="add_to_cart" class="red btn_small btn_inline2">
        Add Current Design to Cart
    </button>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: 'add-to-cart-dq',
    methods: {
        ...mapActions(["addToCart", "saveCart", "emptyNotes"]),
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        objectifyForm(formArray) {
            let result = {};
            for (let i = 0; i < formArray.length; i++){
                result[formArray[i]['name']] = formArray[i]['value'];
            }
            return result;
        },
        async handleAddToCart() {
            await this.sleep(2000)

            const slug = 'box-beam-coffered-ceiling-systems-custom-fit'
            const product = await this.getProductBySlug(slug)

            if(!product) {
                return
            }

            const dq_ind = dqOptions.dq_ind || 0
            const quotes = dqOptions.sending_variables && dqOptions.sending_variables[dq_ind] ? dqOptions.sending_variables[dq_ind] : dqOptions.sending_variables[0]

            if(!quotes) {
                return
            }

            $(".jsapp_success h3").hide();
            $(".jsapp_success p").hide();

            $(".jsapp_success").show();

            this.emptyNotes();
            this.addToCart({
                id: product.id,
                variant_id: null,
                publish_url: product.publish_url,
                title: product.title,
                sku: product.sku,
                type: 'dq_product',
                grouped_product: product.grouped_product,
                is_group_of: !!product.is_group_of,
                options: {},
                options_ids: {},
                price: quotes ? quotes.totalpricedeliveredretail : product.price,
                regular_price: product.regular_price ?? 2852.11,
                image: product.main_image,
                units: product.units,
                quantity: 1,
                uid: null,
                dq_options: quotes
            }).then(res => {
                this.saveCart({page: 'product'})
                $(".jsapp_success h3.dqt_add_to_cart").show();
                $(".jsapp_success p.dqt_add_to_cart").show();
            })
            $(".dq_app > .overlay").removeClass('hide-overlay').fadeOut()
       },
        async getProductBySlug(slug) {
          try {
              const {data} = await axios.get(`${_configs.baseUrl}/product/${slug}`)

              return data && data.product
          } catch (e) {
              console.error('getProductBySlug ERROR: ', e)
              return null
          }
        }
    },
}
</script>
